import React from "react";
import { Link } from "react-router-dom";

export const Brand = ({ className = "" }) => (
  <span className={`cm-brand-name text-xl ${className}`} data-testid="brand-name">
    <span className="care">CARE</span><span className="match">Match</span>
  </span>
);

export const EmergencyBanner = ({ compact = false }) => (
  <div className={`cm-emergency-banner ${compact ? "text-xs py-2" : ""}`} data-testid="emergency-banner">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
    <div>
      <div className="font-semibold text-[#991b1b]">If you think you are experiencing a medical emergency, do not use CAREMatch.</div>
      {!compact && <div className="text-[#7f1d1d]/80 mt-0.5">Call 999 (UK) or your local emergency number immediately, or go to A&amp;E.</div>}
    </div>
  </div>
);

export const StatusBadge = ({ status }) => {
  const map = {
    verified: { cls: "cm-badge-verified", label: "Verified", icon: "✓" },
    pending: { cls: "cm-badge-pending", label: "Pending", icon: "•" },
    under_review: { cls: "cm-badge-pending", label: "Under Review", icon: "•" },
    rejected: { cls: "cm-badge-rejected", label: "Rejected", icon: "×" },
    suspended: { cls: "cm-badge-rejected", label: "Suspended", icon: "×" },
    expired: { cls: "cm-badge-rejected", label: "Expired", icon: "×" },
    confirmed: { cls: "cm-badge-verified", label: "Confirmed", icon: "✓" },
    completed: { cls: "cm-badge-verified", label: "Completed", icon: "✓" },
    pending_payment: { cls: "cm-badge-pending", label: "Awaiting Payment", icon: "•" },
    paid: { cls: "cm-badge-verified", label: "Paid", icon: "✓" },
    unpaid: { cls: "cm-badge-pending", label: "Unpaid", icon: "•" },
  };
  const it = map[status] || { cls: "cm-chip", label: status, icon: "" };
  return <span className={it.cls} data-testid={`status-${status}`}>{it.icon} {it.label}</span>;
};

export const Money = ({ amount, currency = "GBP" }) => {
  const sym = currency === "GBP" ? "£" : currency === "USD" ? "$" : currency + " ";
  const n = Number(amount || 0).toFixed(2).replace(/\.00$/, "");
  return <span>{sym}{n}</span>;
};

export const SectionEyebrow = ({ children }) => (
  <div className="cm-eyebrow mb-3">{children}</div>
);

export const NavItem = ({ to, label, active, testid, icon }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all ${
      active
        ? "bg-[#ebf3fc] text-[#1a2b4a]"
        : "text-[#475569] hover:bg-[#f5f7fa] hover:text-[#1a2b4a]"
    }`}
  >
    {icon && <span className="w-4 h-4 flex-shrink-0">{icon}</span>}
    {label}
  </Link>
);
